import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap5';

import { useContext as useUsersContext } from 'components/Users/Context';

import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';

import Actions from '../Actions';

export default function SlackLinked({ channels }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const onDeleteSlack = () => {
    Actions.unlinkSlack(stateUsers.user.attributes.slack_user_id, () => {
      actionsUsers.load(dispatchUsers);
    });
  };

  return (
    <div className="mt-4">
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          <div>
            <p>
              Your Slack account is connected. You can now receive personalized
              coaching notifications and interact with your LeggUP AI Health and
              Performance Coach directly through Slack.
            </p>
            <p>To disconnect your account, click the Slack button above.</p>
            <p>
              Please select a Slack channel where you&apos;d like to receive
              your coaching notifications and reminders:
            </p>
            <HorizontalSelectField
              name="slackChannelId"
              placeholder="Select"
              options={channels.channels.map((el) => ({
                label: el.name,
                value: el.channel_id,
              }))}
              isClearable
              menuPlacement="top"
            />
          </div>
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-end">
            <Button onClick={onDeleteSlack} variant="outline-primary">
              Slack
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

SlackLinked.propTypes = {
  channels: PropTypes.object.isRequired,
};
